import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DEFAULT_LANGUAGE } from 'app/config/languages.config';
import { loadAngularLocale } from 'app/custom-class/locale-loader';
import { VocabularyService } from 'app/server/services/vocabulary.service';
import { Utils } from 'app/custom-class/utils';

export function translationInitializer(_translateService: TranslateService, _vocabularyService: VocabularyService) {
	Utils.translateService = _translateService;

	return () => {
		return new Promise<void>(resolve => {
			// The backend is the single source of truth for which languages actually have
			// vocabulary data; fall back to the static frontend list if the call fails.
			_vocabularyService
				.getSupportedLanguages()
				.pipe(catchError(() => of(null)))
				.subscribe(() => {
					const supportedLangCodes = _vocabularyService.supportedLangCodes;

					_translateService.addLangs(supportedLangCodes);
					_translateService.setDefaultLang(DEFAULT_LANGUAGE.code);

					// Automatically load Angular CLDR locale on every language change, and
					// keep Utils.currentLang in sync — static utilities (no DI) that need
					// the active language, like Utils.formatDate, read it from here rather
					// than localStorage, which lags behind the real active language until
					// the user has manually switched it at least once via the navbar.
					_translateService.onLangChange.subscribe(event => {
						loadAngularLocale(event.lang);
						Utils.currentLang = event.lang;
					});

					const savedLang = localStorage.getItem('language');
					const browserLang = _translateService.getBrowserLang();
					const candidateLang = savedLang || browserLang || DEFAULT_LANGUAGE.code;
					const langToUse = supportedLangCodes.includes(candidateLang) ? candidateLang : DEFAULT_LANGUAGE.code;

					loadAngularLocale(langToUse).finally(() => {
						_translateService.use(langToUse).subscribe({
							next: () => {
								resolve();
							},
							error: () => {
								resolve();
							},
						});
					});
				});
		});
	};
}
